import { render, staticRenderFns } from "./ClientEditPageDynamic.vue?vue&type=template&id=6486714c"
import script from "./ClientEditPageDynamic.vue?vue&type=script&lang=js"
export * from "./ClientEditPageDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports